import {
  $ABTest,
  $I18nText,
  $Locale,
  $RenderConfig,
  $RootTraffic,
  $UserAgent,
  $WebUser,
  $CSPScripts,
} from '@lemon8/web-app-shared/atom';
import { $HomepageMaterial } from 'shared/atoms/homepage-material';

export const Atoms = {
  $Locale,
  $ABTest,
  $RenderConfig,
  $WebUser,
  $UserAgent,
  $I18nText,
  $RootTraffic,
  $HomepageMaterial,
  $CSPScripts,
};

export const AtomFamilies = {} as const;

export * from './common';
export * from './enable-pinterest';
